import { PointHistoryAdminForm } from "./point-history-admin-form";
import { PointHistoryAdminHandler } from "./point-history-admin-handler";
import { PointHistoryAdminListener } from "./point-history-admin-listener";

interface PointHistoryAdminOptions {
    userId: number;
    onReload: () => Promise<void>;
}

export class PointHistoryAdminSetup {
    public panel: HTMLElement;

    public form: PointHistoryAdminForm;

    public handler: PointHistoryAdminHandler;

    public listener: PointHistoryAdminListener;

    public constructor(panel: HTMLElement, options: PointHistoryAdminOptions) {
        this.panel = panel;
        this.form = new PointHistoryAdminForm(panel);
        this.handler = new PointHistoryAdminHandler(this.form, options);
        this.listener = new PointHistoryAdminListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.panel instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;
        this.form.markInitialized();
        this.listener.register();
    }

    public static init(panel: HTMLElement, options: PointHistoryAdminOptions): PointHistoryAdminSetup {
        const setup = new PointHistoryAdminSetup(panel, options);
        setup.init();
        return setup;
    }
}
